import _ from 'lodash';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { FeeProvidersTreeItemType } from 'constants/feeTypes';

import { selectFeeProviderValues } from './feeProvider.selectors';
import { getSystem } from './system.selectors';

const selectFeeProviderCategories = createSelector(
  getSystem,
  ({ feeProviderCategory }) => feeProviderCategory,
);

export const selectFeeProviderCategoriesValues = createSelector(
  selectFeeProviderCategories,
  feeProviderCategories =>
    Object.values(feeProviderCategories).map(feeProviderCategory => ({
      ...feeProviderCategory,
      feeProviderCategoryId: feeProviderCategory.feeProviderCategoryId ?? feeProviderCategory.id,
    })),
);

export const selectFeeProviderCategoryById = memoizeOne(id =>
  createSelector(selectFeeProviderCategories, feeProviderCategories => feeProviderCategories[id]),
);

export const selectFeeProviderCategoryTree = createSelector(
  selectFeeProviderCategoriesValues,
  selectFeeProviderValues,
  (feeProviderCategories, feeProviders) =>
    _.sortBy(
      [
        ...feeProviderCategories.map(({ feeProviderCategoryId, name }) => ({
          id: feeProviderCategoryId,
          parentId: null,
          name,
          type: FeeProvidersTreeItemType.FEE_PROVIDER_CATEGORY,
        })),
        ...feeProviders.map(({ feeProviderCategoryId, feeProviderId, name, companyId }) => ({
          id: feeProviderId,
          parentId: feeProviderCategoryId,
          name,
          type: FeeProvidersTreeItemType.FEE_PROVIDER,
          companyId,
        })),
      ],
      [({ name }) => _.toLower(name)],
      ['asc'],
    ),
);
